module.exports = __webpack_public_path__ + "img/logo_grey.f1365280.svg";